import React, { memo, useState, useEffect, useCallback, useRef } from 'react';
import { getHoldTimerState } from '@utility/helperFunction';
import { HoldTimerIcon } from '@assets/images/HoldIcons/holdTimer.jsx';

const HOLD_RESET = { timeStr: '00:00', isPositive: true };

const HoldTimerText = memo(({ sendDate, serverAppTheme }) => {
  const [timerState, setTimerState] = useState(
    () => sendDate ? getHoldTimerState(sendDate) : HOLD_RESET
  );
  const prevPositiveRef = useRef(timerState.isPositive);

  useEffect(() => {
    if (!sendDate) return;
    const tick = () => setTimerState(getHoldTimerState(sendDate) || HOLD_RESET);
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [sendDate]);

  useEffect(() => {
    if (timerState.isPositive !== prevPositiveRef.current) {
      prevPositiveRef.current = timerState.isPositive;
      // onFlip?.(timerState.isPositive);
    }
  }, [timerState.isPositive]);

  const { timeStr, isPositive } = timerState;
  // const color = isPositive
  //   ? serverAppTheme?.holdPositive
  //   : serverAppTheme?.holdNegative;
  return (
    <span className="fs-12 fw-600 pl-1" style={{ color: '#000' }}>
      {timeStr}
    </span>
  );
});

const HoldTimerBadge = memo(({ sendDate, serverAppTheme }) => {
  const initialState =
    (sendDate ? getHoldTimerState(sendDate) : null) || HOLD_RESET;
  // const [iconFill, setIconFill] = useState(
  //   initialState.isPositive
  //     ? serverAppTheme?.holdPositive
  //     : serverAppTheme?.holdNegative
  // );
  const themeRef = useRef(serverAppTheme);
  themeRef.current = serverAppTheme;

  // const handleFlip = useCallback(isPositive => {
  //   setIconFill(
  //     isPositive
  //       ? themeRef.current?.holdPositive
  //       : themeRef.current?.holdNegative
  //   );
  // }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: '2px',
        paddingLeft: '4px',
      }}
    >
      <HoldTimerIcon width={14} height={14} fill={'#000'} />
      <HoldTimerText
        sendDate={sendDate}
        serverAppTheme={serverAppTheme}
        // onFlip={handleFlip}
      />
    </div>
  );
});

export { HoldTimerBadge, HoldTimerText };
export default HoldTimerBadge;
